import { WalmartLandingPage } from 'pages/loyalty/loyalty-partners/walmart';
import { useWalmartDisabledPage } from 'pages/loyalty/loyalty-partners/walmart/use-walmart-disabled-redirect';

export default function WalmartPlusPage() {
  const disabledRedirect = useWalmartDisabledPage();
  if (disabledRedirect) {
    return disabledRedirect;
  }

  return <WalmartLandingPage />;
}
